export const selectedVideo = (state) => {
  return state.selectedVideo || null
}

export const getSelectedVideoProgram = (state) => {
  return state.selectedVideo.programs
}
